module.exports = __webpack_public_path__ + "static/youtube-26b8dec4b2007793bc6ba6f6d3863b93.png";